import React, { useState } from 'react';
import {
  IconButton,
  Menu,
  MenuItem,
  ListItemIcon,
  ListItemText,
  Tooltip,
} from '@material-ui/core';
import {
  MoreVert as MoreVertIcon,
  Visibility as VisibilityIcon,
  Description as DescriptionIcon,
} from '@material-ui/icons';

const FilaAcciones = ({ row, onVerDetalle, onVerConvenio }) => {
  const [anchorEl, setAnchorEl] = useState(null);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleVerPractica = () => {
    handleClose();
    if (onVerDetalle) onVerDetalle(row);
  };

  const handleVerConvenio = () => {
    handleClose();
    if (onVerConvenio) onVerConvenio(row.convenioId);
  };

  return (
    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      <Tooltip title="Acciones" arrow>
        <IconButton
          size="small"
          onClick={handleClick}
          aria-label="acciones"
        >
          <MoreVertIcon />
        </IconButton>
      </Tooltip>

      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
      >
        <MenuItem onClick={handleVerPractica}>
          <ListItemIcon>
            <VisibilityIcon fontSize="small" color="primary" />
          </ListItemIcon>
          <ListItemText primary="Ver práctica" />
        </MenuItem>

        <MenuItem onClick={handleVerConvenio}>
          <ListItemIcon>
            <DescriptionIcon fontSize="small" style={{ color: '#1976d2' }} />
          </ListItemIcon>
          <ListItemText primary="Ver convenio" />
        </MenuItem>
      </Menu>
    </div>
  );
};

export default FilaAcciones;
